import { EDateFormat } from 'detailsv2/structure';

import { DD_MM_YYYY_FORMAT, MM_DD_YYYY_FORMAT } from '../../i18n';

export const getTranslationDateFormat = (dateFormat?: EDateFormat) => {
  if (dateFormat === EDateFormat.DMY) {
    return DD_MM_YYYY_FORMAT;
  }

  return MM_DD_YYYY_FORMAT;
};
